import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { SharedModule } from "../../../shared/shared.module";
import { CreateMaintenanceProviderComponent } from "./create-maintenance-provider/create-maintenance-provider.component";
import { MaintenanceProviderComponent } from "./maintenance-provider.component";
import { ManageMaintenanceProviderComponent } from "./manage-maintenance-provider/manage-maintenance-provider.component";

@NgModule({
  declarations: [CreateMaintenanceProviderComponent, MaintenanceProviderComponent, ManageMaintenanceProviderComponent],
  imports: [CoreModule, SharedModule],
  exports: [CreateMaintenanceProviderComponent, MaintenanceProviderComponent, ManageMaintenanceProviderComponent],
})
export class MaintenanceProviderModule {}
